const onboarding = state => state.onboarding;

export default onboarding;
